export const retiredSearchSubpaths: string[] = [
  'reminder',
  'facet',
  'mm',
  'promo',
  'ab228-b',
  'sort',
]
